// Added by Russlan 2019-02-22 (file)
import React from "react";
import {browserHistory} from "react-router";

export default class MapObjectSummary extends React.Component {
    
    onClick() {
        const object = (this.props.lastClickedObject) ? this.props.lastClickedObject : (this.props.object) ? this.props.object : this.props.hoverObject;
        //const object = this.props.object;        

        if (object){
            let url = `${this.props.location.pathname}/object/${object.number}`;
            browserHistory.push(url);    
        }
    }

    render () {
        //const props = this.props;
        
        //var debugHelper = `O:"${(this.props.object) ? this.props.object.guid : '-'}"-L:"${(this.props.lastClickedObject) ? this.props.lastClickedObject.guid : '-'}"-H:"${(this.props.hoverObject) ? this.props.hoverObject.guid : '-'}"`;
        
        var object = this.props.lastClickedObject;

        if (!object) object = this.props.object;

        const style = {
            left: 0,
            top: 0,
        };

        var componentContent = null;

        // <div className="cw-map-object-number">{object.number} - {debugHelper}</div>
        if (object)
        {
            componentContent = (
                <div className="cw-map-object-summary-content">
                    {/* <div className="cw-map-object-number">{object.number}</div> */}
                            <table className="summary-table">
                                <tbody>
                                <tr>
                                    <td className="no-wrap"><span className="content-label">Objektnr: </span><span className="content-data">{object.number}</span></td>
                                    <td className="no-wrap"><span className="content-label">Våning: </span><span className="content-data">{object.data['floor_number']}</span></td>
                                </tr>
                                <tr>
                                    <td className="no-wrap"><span className="content-label">Rum: </span><span className="content-data">{object.data['rooms']} rok</span></td>
                                    {object.data['price'] && <td className="no-wrap"><span className="content-label">Pris: </span><span className="content-data">{object.data['price'].formatted}</span></td>}
                                    {!object.data['price'] && <td className="no-wrap"><span className="content-label">Pris: </span><span className="content-data">-</span></td>}
                                </tr>
                                <tr>
                                    {object.data['monthly_fee'] && <td className="no-wrap"><span className="content-label">Avgift: </span><span className="content-data">{object.data['monthly_fee'].formatted}</span></td>}
                                    {!object.data['monthly_fee'] && <td className="no-wrap"><span className="content-label">Avgift: </span><span className="content-data">-</span></td>}
                                    <td className="no-wrap"><span className="content-label">Boarea: </span><span className="content-data">{object.data['living_area']} m<sup>2</sup></span></td>                                    
                                </tr>
                                <tr>
                                <td className="no-wrap"><span className="content-label">Status: </span><span className="content-data"><span className={'status-blob status-blob-' + object.status}></span> {object.status_name}</span></td>
                                    <td className="no-wrap"><button onClick={this.onClick.bind(this)} className="cw-object-open-bttn" type="button">Mer detaljer</button></td>
                                </tr>                                        
                                </tbody>
                            </table>
                </div>)
        }

        return (<div id="object-summary" className="cw-map-object-summary" style={style}>{componentContent}</div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/MapObjectSummary.jsx